import styled from 'styled-components'

export const Wrapper = styled.div`
  .row {
    > div {
      width: 50%;
      margin: 0 5px;
    }
  }

  p {
    margin: 0 0 15px 5px;
  }

  .checkbox {
    margin-bottom: 15px;
    display: block;

    input {
      margin-right: 10px;
    }
  }

  label {
    font-size: 18px;
  }
`
